import { initializeApp } from 'firebase/app';
import {
    connectAuthEmulator,
    getAuth,
    signInWithEmailAndPassword,
} from 'firebase/auth';

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const firebaseApp = initializeApp(firebaseConfig);

const auth = getAuth();

// Point the browser SDK at a local Firebase Auth emulator when one is running,
// so an automated regression pass can sign in as each role without a password
// being typed. Unset in every normal run, including production builds, and the
// SDK then talks to real Firebase exactly as before.
//
// The port is not fixed at the stock 9099: scripts/development/start-container
// derives it from PORT_OFFSET (9099 + offset), because two projects both sitting
// on 9099 do not fail loudly. The Auth emulator is multi-tenant by project id, so
// the second project authenticates against the first one's emulator, sign-in
// succeeds, and the server then finds no profile for a UID belonging to another
// project's fixtures.
//
// The host is required to be loopback. Without that check a stray or injected
// value could send real users' credentials to an arbitrary host, so the variable
// is treated as untrusted input even though it is developer-supplied.
const emulatorHost = process.env.REACT_APP_FIREBASE_AUTH_EMULATOR_HOST;
if (emulatorHost) {
    if (/^(127\.0\.0\.1|localhost|\[::1\]):\d+$/.test(emulatorHost)) {
        connectAuthEmulator(auth, `http://${emulatorHost}`, {
            disableWarnings: true,
        });
        // Let an automated pass sign in through the SDK itself rather than by
        // driving the login form or forging a persistence record, either of
        // which tests the harness instead of the application.
        //
        // Reachable ONLY from inside this branch, so it cannot exist in a real
        // build: the branch requires a loopback emulator host, any other value
        // throws below, and the server refuses to boot when the matching server
        // variable is set outside development.
        if (typeof window !== 'undefined') {
            window.__authEmulatorTestHooks = {
                auth,
                signInWithEmailAndPassword,
            };
        }
    } else {
        // Loud rather than silent: a misconfigured host means the pass is
        // authenticating somewhere unintended, which must not look like success.
        throw new Error(
            `REACT_APP_FIREBASE_AUTH_EMULATOR_HOST must be a loopback address, got "${emulatorHost}"`
        );
    }
}

export default {
    firebaseApp,
    auth,
};
